import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-webinar-popup',
    templateUrl: './webinar-popup.component.html',
    styleUrls: ['./webinar-popup.component.scss'],
    standalone: false
})

export class WebinarPopupComponent implements OnInit {
   private isBrowser: boolean;
  constructor(public activeModal: NgbActiveModal, @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
  }

  goToLink(url: string){
    if (this.isBrowser) {
      this.activeModal.dismiss()
      window.open(url, "_blank");
    }
  }

}
